import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
import { Divider as Divider$1 } from "./Divider.js";
import { useToolbarContext } from "./context9.js";
function Divider(props) {
  const {
    direction
  } = useToolbarContext();
  return /* @__PURE__ */ jsx(DividerContainer, {
    $direction: direction,
    ...props,
    children: /* @__PURE__ */ jsx(Divider$1, {
      direction: direction === "horizontal" ? "vertical" : "horizontal"
    })
  });
}
const DividerContainer = styled.div.withConfig({
  displayName: "DividerContainer",
  componentId: "sc-17qlg5r-0"
})(["margin:", ";"], (props) => props.$direction === "horizontal" ? `calc(${token.spacing2} * -1) 0 ` : `0 calc(${token.spacing2} * -1) `);
export {
  Divider
};
//# sourceMappingURL=Divider2.js.map
